'use strict';
        var $dep = require('../dependency'),
        _ = $dep._,
        apiRequest = $dep.apiRequest,
        config = require('../config'),
        $u = require('../utilities');
        var GRAPHS = config.graphs,
        $d = config.druid;
        var chartId = 'FEATURES_BY_PERCENT_CUSTOMERS',
        chartType = 'POINT_IN_TIME',
        filters = [config.filters.DATE],
        dataRotateMapping = [{
                name: 'Guest Insights',
                field: 'gmsActiveAnalyticsCount'
            }, {
                name: 'Splash Page',
                field: 'customersWithGuestProfiles'
            }, {
                name: 'Bandwidth Allocation',
                field: 'customersWithBandwidthAllocation'
            }, {
                name: 'Content Filtering',
                field: 'customersWithContentFiltering'
            }, {
                name: 'SSID Scheduling',
                field: 'customersWithSsidScheduling'
            }, {
                name: 'Social Media Login',
                field: 'socialMediaLogin'
            }],
        dataSeries = {
            TIMESTAMP: 'timestamp',
            GUEST_INSIGHTES: 'gmsActiveAnalyticsCount',
            BANDWIDTH_ALLOCATION: 'customersWithBandwidthAllocation',
            GUEST_PROFILES: 'customersWithGuestProfiles',
            SSID_SCHEDULING: 'customersWithSsidScheduling',
            CONTENT_FILTERING: 'customersWithContentFiltering',
            CONTENT_FILTERING1: 'customersWithContentFiltering1',
            CONTENT_FILTERING2: 'customersWithContentFiltering2',
            CONTENT_FILTERING3: 'customersWithContentFiltering3',
            SOCIAL_MEDIA_LOGIN: 'socialMediaLogin',
            WECHAT_ENABLED: 'weChatEnabled',
            FOURSQUARE_ENABLED: 'foursquareEnabled',
            INSTAGRAM_ENABLED: 'instagramEnabled',
            LINKEDIN_ENABLED: 'linkedInEnabled',
            FACEBOOK_ENABLED: 'facebookEnabled',
            GPLUS_ENABLED: 'googlePlusEnabled',
            TWITTER_ENABLED: 'twitterEnabled'
        },
fieldNames = {
    GUEST_INSIGHTES: 'gmsActiveAnalyticsCount',
    BANDWIDTH_ALLOCATION: 'amcNumOfSsidProfilesBeingUsedInTemplateWithUserBandwidthControlEnabled',
    GUEST_PROFILES: 'amcNumOfSsidProfilesBeingUsedInTemplatesWithCaptivePortalEnabled',
    SSID_SCHEDULING: 'amcNumOfSsidProfilesBeingUsedInTemplateWithSsidScheduling',
    CONTENT_FILTERING: 'customersWithContentFiltering',
    CONTENT_FILTERING1: 'amcNumOfManagedDevicesUsingConnectSafePolicySecurityPornOther',
    CONTENT_FILTERING2: 'amcNumOfManagedDevicesUsingConnectSafePolicySecurityPorn',
    CONTENT_FILTERING3: 'amcNumOfManagedDevicesUsingConnectSafePolicySecurity',
    SOCIAL_MEDIA_LOGIN: 'socialMediaLogin',
    WECHAT_ENABLED: 'gmsPortalWeChatEnabledCount',
    FOURSQUARE_ENABLED: 'gmsPortalFoursquareEnabledCount',
    INSTAGRAM_ENABLED: 'gmsPortalInstagramEnabledCount',
    LINKEDIN_ENABLED: 'gmsPortalLinkedInEnabledCount',
    FACEBOOK_ENABLED: 'gmsPortalFacebookEnabledCount',
    GPLUS_ENABLED: 'gmsPortalGPlusEnabledCount',
    TWITTER_ENABLED: 'gmsPortalTwitterEnabledCount'
},
/**
 * [dataConfig The query params to pass to the API http endpoint POST. Currently this are specific to druid querying.
 * can be modified for other data provider systems.]
 * @type {Object}
 */
dataConfig = [{
        queryType: 'groupBy',
        /*!ToDo above use this from druid settings object (settings maybe in matrix charts)*/
        dataSource: 'babbage',
        /*above Can be set in library matrix charts*/
        dimensions: ['customer'],
        aggregations: [{
                type: 'javascript',
                name: dataSeries.GUEST_INSIGHTES,
                fieldNames: [fieldNames.GUEST_INSIGHTES],
                fnAggregate: $d.aggregateFunction,
                fnCombine: $d.aggregateCombineFunction,
                fnReset: $d.aggregateResetFunction
            }, {
                type: 'javascript',
                name: dataSeries.BANDWIDTH_ALLOCATION,
                fieldNames: [fieldNames.BANDWIDTH_ALLOCATION],
                fnAggregate: $d.aggregateFunction,
                fnCombine: $d.aggregateCombineFunction,
                fnReset: $d.aggregateResetFunction
            }, {
                type: 'javascript',
                name: dataSeries.GUEST_PROFILES,
                fieldNames: [fieldNames.GUEST_PROFILES],
                fnAggregate: $d.aggregateFunction,
                fnCombine: $d.aggregateCombineFunction,
                fnReset: $d.aggregateResetFunction
            }, {
                type: 'javascript',
                name: dataSeries.SSID_SCHEDULING,
                fieldNames: [fieldNames.SSID_SCHEDULING],
                fnAggregate: $d.aggregateFunction,
                fnCombine: $d.aggregateCombineFunction,
                fnReset: $d.aggregateResetFunction
            }, {
                type: 'javascript',
                name: dataSeries.CONTENT_FILTERING1,
                fieldNames: [fieldNames.CONTENT_FILTERING1],
                fnAggregate: $d.aggregateFunction,
                fnCombine: $d.aggregateCombineFunction,
                fnReset: $d.aggregateResetFunction
            }, {
                type: 'javascript',
                name: dataSeries.CONTENT_FILTERING2,
                fieldNames: [fieldNames.CONTENT_FILTERING2],
                fnAggregate: $d.aggregateFunction,
                fnCombine: $d.aggregateCombineFunction,
                fnReset: $d.aggregateResetFunction
            }, {
                type: 'javascript',
                name: dataSeries.CONTENT_FILTERING3,
                fieldNames: [fieldNames.CONTENT_FILTERING3],
                fnAggregate: $d.aggregateFunction,
                fnCombine: $d.aggregateCombineFunction,
                fnReset: $d.aggregateResetFunction
            }, {
                type: 'javascript',
                name: dataSeries.FACEBOOK_ENABLED,
                fieldNames: [fieldNames.FACEBOOK_ENABLED],
                fnAggregate: $d.aggregateFunction,
                fnCombine: $d.aggregateCombineFunction,
                fnReset: $d.aggregateResetFunction
            }, {
                type: 'javascript',
                name: dataSeries.LINKEDIN_ENABLED,
                fieldNames: [fieldNames.LINKEDIN_ENABLED],
                fnAggregate: $d.aggregateFunction,
                fnCombine: $d.aggregateCombineFunction,
                fnReset: $d.aggregateResetFunction
            }, {
                type: 'javascript',
                name: dataSeries.GPLUS_ENABLED,
                fieldNames: [fieldNames.GPLUS_ENABLED],
                fnAggregate: $d.aggregateFunction,
                fnCombine: $d.aggregateCombineFunction,
                fnReset: $d.aggregateResetFunction
            }, {
                type: 'javascript',
                name: dataSeries.TWITTER_ENABLED,
                fieldNames: [fieldNames.TWITTER_ENABLED],
                fnAggregate: $d.aggregateFunction,
                fnCombine: $d.aggregateCombineFunction,
                fnReset: $d.aggregateResetFunction
            }, {
                type: 'javascript',
                name: dataSeries.INSTAGRAM_ENABLED,
                fieldNames: [fieldNames.INSTAGRAM_ENABLED],
                fnAggregate: $d.aggregateFunction,
                fnCombine: $d.aggregateCombineFunction,
                fnReset: $d.aggregateResetFunction
            }, {
                type: 'javascript',
                name: dataSeries.FOURSQUARE_ENABLED,
                fieldNames: [fieldNames.FOURSQUARE_ENABLED],
                fnAggregate: $d.aggregateFunction,
                fnCombine: $d.aggregateCombineFunction,
                fnReset: $d.aggregateResetFunction
            }, {
                type: 'javascript',
                name: dataSeries.WECHAT_ENABLED,
                fieldNames: [fieldNames.WECHAT_ENABLED],
                fnAggregate: $d.aggregateFunction,
                fnCombine: $d.aggregateCombineFunction,
                fnReset: $d.aggregateResetFunction
            }],
        postAggregations: [{
                type: 'javascript',
                name: dataSeries.CONTENT_FILTERING,
                fieldNames: [
                    dataSeries.CONTENT_FILTERING1,
                    dataSeries.CONTENT_FILTERING2,
                    dataSeries.CONTENT_FILTERING3
                ],
                function: $d.aggregateCombineFunction
            }, {
                type: 'javascript',
                name: dataSeries.SOCIAL_MEDIA_LOGIN,
                fieldNames: [
                    dataSeries.FACEBOOK_ENABLED,
                    dataSeries.LINKEDIN_ENABLED,
                    dataSeries.GPLUS_ENABLED,
                    dataSeries.TWITTER_ENABLED,
                    dataSeries.FOURSQUARE_ENABLED,
                    dataSeries.INSTAGRAM_ENABLED,
                    dataSeries.WECHAT_ENABLED
                ],
                function: $d.aggregateCombineFunction
            }]
    }],
        dataSeriesFields = ['features', 'customers', 'customerPercentage'],
        modelFieldKeys = $u.charts.generateFieldKeysArray(dataConfig, dataSeriesFields),
        aggregationFields = _.chain(dataSeries).values().without(dataSeries.TIMESTAMP).value(),
        tasks = [
            'durationFilter',
            'druidQueryGenerator',
            'druidQueryValidator',
            'fetchChartData',
            'druidResponseParser', {
                name: 'afterApiAggregationCustomerPercentage',
                config: {
                    aggregationFields: aggregationFields
                }
            }, {
                plugin: modifyResponse
            }, {
                name: 'updateChartModelData',
                config: {
                    dataSeriesFields: dataSeriesFields,
                    modelFieldKeys: modelFieldKeys
                }
            }
        ];

exports.chartId = chartId;
exports.chartType = chartType;
exports.dataSeries = dataSeries;
exports.fieldNames = fieldNames;
exports.filters = filters;
exports.dataConfig = dataConfig;
exports.dataSeriesFields = dataSeriesFields;
exports.modelFieldKeys = modelFieldKeys;
exports.tasks = tasks;
exports.chartTemplate = chartTemplate;
exports.i18n = config.graphs.CHART_METADATA.FEATURES_BY_PERCENT_CUSTOMERS;



function modifyResponse(context, config, next) {
        var model = context.apiMergedResponse,
                computedModel = {},
                featureName,
                featureFieldName;

    // there is a special requirement to fetch last 30 days data from selected date 
    // only for "gmsActiveAnalyticsCount" metric
    // so we fetch it from separate API call and replace it in the result data
    var selectedDate = new Date(context.intervals[0][0].substr(25,24));
    var guestInsightsDataStartDate = new Date(selectedDate.getTime() - 2592000000); // milliseconds in 30 days
    
    var guestInsightsDataQuery = {
        "aggregations": [
            {
                type: 'javascript',
                name: dataSeries.GUEST_INSIGHTES,
                fieldNames: [fieldNames.GUEST_INSIGHTES],
                fnAggregate: $d.aggregateFunction,
                fnCombine: $d.aggregateCombineFunction,
                fnReset: $d.aggregateResetFunction
            }],
        "dataSource": "babbage",
        "dimensions": ["customer"],
        "granularity": "all",
        "intervals": [guestInsightsDataStartDate.toISOString() + "/" + selectedDate.toISOString()],
        "queryType": "groupBy"
    };

    apiRequest({
        url: context.apiPath,
        data: JSON.stringify(guestInsightsDataQuery),
        dataType: 'json',
        type: 'POST',
        contentType: 'application/json'
    }).then(function (guestInsightsDataResponse) {
        
        var guestInsightsCount = 0;
        
        _.forEach(guestInsightsDataResponse, function (customerObject) {
            guestInsightsCount += (customerObject.event.gmsActiveAnalyticsCount ? 1 : 0);
        });
       
        model[fieldNames.GUEST_INSIGHTES] = guestInsightsCount;
        model[fieldNames.GUEST_INSIGHTES + "_percentage"] = 100 * guestInsightsCount / guestInsightsDataResponse.length;

        // logic to add 30 days of data for "gmsActiveAnalyticsCount" completed

        _.forEach(dataRotateMapping, function (singlePluginMapping) {
            featureName = singlePluginMapping.name;
            featureFieldName = singlePluginMapping.field;

            if (!computedModel.features) {
                computedModel.features = [];
            }
            computedModel.features.push(featureName);

            if (!computedModel.customers) {
                computedModel.customers = [];
                computedModel.customerPercentage = [];
            }
            if (model[featureFieldName]) {
                computedModel.customers.push(model[featureFieldName]);
                computedModel.customerPercentage.push(model[featureFieldName + "_percentage"]);
            } else {
                computedModel.customers.push(0);
                computedModel.customerPercentage.push(0);
            }


            delete model[featureName];
        });

        if ($u.charts.allEqualElemArray(computedModel.customerPercentage, 0) ||
                $u.charts.allEqualElemArray(computedModel.customerPercentage, null)
                ) {
            context.zeroDataFlag = true;
        }

        context.chartData = computedModel;
        next();

    });
}

function chartTemplate(data, width) {
    /*!ToDo chech y width is a string in px*/
    width = parseInt(width.match(/\d+/g)[0], 10);

    var duration = data.__duration,
            xAxisLabelOffset = $u.charts.getXaxisOffset(duration),
            x = xAxisLabelOffset.x,
            y = xAxisLabelOffset.y,
            legendAdjustments = $u.charts.getLegendAdjustments(duration, false, false),
            pointWidth = width / 50;

    var yAxisBaseUnit = '',
            yAxisRoundOff = true,
            yAxisFormatter = $u.charts.chartYaxisFormatter,
            yAxisTrimDecimalPlaces = 2;

//    var y1Max = _.max(data.customerPercentage), y2Max = _.max(data.customers);

    var chartTemplateObj = {
        dataTableConfig: {
            customDateString: data.__generationDateString,
            duration: duration,
            yAxisFormatter: yAxisFormatter,
            yAxisBaseUnit: yAxisBaseUnit,
            yAxisRoundOff: yAxisRoundOff,
            xAxisDataHeader: 'Features',
            yAxisTrimDecimalPlaces: yAxisTrimDecimalPlaces
        },
        chart: {
            type: 'column',
            zoomType: 'x,y',
            alignTicks: false,
            marginTop: GRAPHS.GLOBAL.CHART_MARGINS.TOP,
            marginBottom: GRAPHS.GLOBAL.CHART_MARGINS.BOTTOM,
            events: {
                load: function () {
                    var dataUnit,
                            chartContext = this,
                            dataArray;

                    _.forEach(chartContext.yAxis, function (yAxisObject) {
                        dataArray = [];
                        dataUnit = ' ';
                        _.forEach(yAxisObject.series, function (seriesItem) {
                            dataArray.push(seriesItem.dataMax);
                        });
                        dataUnit = $u.charts.getUnitsFromMax(_.max(dataArray), '').unit;
//                        yAxisObject.setTitle({
//                            text: GRAPHS.CHART_METADATA.FEATURES_BY_PERCENT_CUSTOMERS.YAXIS_TEXT + ' ' + dataUnit
//                        });
                    });
                }
            }
        },
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },
        tooltip: {
            formatter: function () {
                var that = this,
                        tooltipUnitObj = yAxisFormatter(that.y, that.series.dataMax, yAxisBaseUnit, yAxisRoundOff, yAxisTrimDecimalPlaces);

                return $u.charts.sformat('{0}: {1}%',
                        that.x,
                        tooltipUnitObj.value
                        );
            },
            percentageDecimals: 0
        },
        legend: {
            y: legendAdjustments.y,
            itemDistance: legendAdjustments.itemDistance
        },
        xAxis: {
            categories: data.features,
            tickmarkPlacement: 'on',
            labels: {
                rotation: -45,
                align: 'center',
                x: x,
                y: y + 10,
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                formatter: function () {
                    return this.value;
                },
                useHTML: true,
                autoTransform: true
            }
        },
        yAxis: [{
                title: {
                    text: GRAPHS.CHART_METADATA.FEATURES_BY_PERCENT_CUSTOMERS.YAXIS1_TEXT,
                    style: {
                        fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_TITLE,
                        color: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY
                    }
                },
                allowDecimals: false,
                min: 0,
//                endOnTick: false,
//                max:y1Max,
//            tickInterval: y1Max/4,
                maxPadding: 0,
                lineColor: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY,
                lineWidth: 1,
                labels: {
                    format: '{value}',
                    formatter: function () {
                        var that = this,
                                yAxisValue = that.value,
                                yMaxValue = that.axis.dataMax;
                        return yAxisFormatter(yAxisValue, yMaxValue,
                                yAxisBaseUnit, yAxisRoundOff, yAxisTrimDecimalPlaces).value + '%';
                    },
                    style: {
                        fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                        fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                    },
                    x: -20
                }
            }
//            ,{
//                title: {
//                    text: GRAPHS.CHART_METADATA.FEATURES_BY_PERCENT_CUSTOMERS.YAXIS2_TEXT,
//                    style: {
//                        fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_TITLE,
//                        color: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY
//                    }
//                },
//                allowDecimals: false,
//                min: 0,
//                endOnTick: false,
//                max:y2Max,
//            tickInterval: y2Max/4,
//                maxPadding: 0,
//                lineColor: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY,
//                lineWidth: 1,
//                gridLineWidth: 0,
//                labels: {
//                    format: '{value}',
//                    formatter: function () {
//                        var that = this,
//                                yAxisValue = that.value,
//                                yMaxValue = that.axis.dataMax;
//                        return yAxisFormatter(yAxisValue, yMaxValue,
//                                yAxisBaseUnit, false, yAxisTrimDecimalPlaces).value; // no rounding off
//                    },
//                    style: {
//                        fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
//                        fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
//                    },
//                    x: 10
//                },
//                opposite: true
//            }
            ],
        plotOptions: {
            column: {
                dataLabels: {
                    enabled: false,
                    color: GRAPHS.GLOBAL.COLORS.MOJO_OFF_WHITE
                }
            },
            series: {
                pointWidth: pointWidth
            }
        },
        series: [{
                showInLegend: false,
                name: '% of Customers',
                data: data.customerPercentage,
                yAxis: 0,
                color: GRAPHS.GLOBAL.COLORS.MOJO_BLUE,
                borderColor: GRAPHS.GLOBAL.COLORS.MOJO_BLUE
            }
//            ,{
//                showInLegend: false,
//                name: 'No. of Customers',
//                data: data.customers,
//                visible: false,
//                yAxis: 1,
//                color: GRAPHS.GLOBAL.COLORS.MOJO_BLUE,
//                borderColor: GRAPHS.GLOBAL.COLORS.MOJO_BLUE
//            }
        ]
    };
    chartTemplateObj = _.assign({}, config.defaultSettings, chartTemplateObj);
    return chartTemplateObj;
}
